// This file is maintained for backward compatibility
// Import the useAuth hook from the auth context
import { useAuth as contextUseAuth } from '../context/auth';

// Re-export it
export const useAuth = contextUseAuth;